// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2NLs9","gfeWrapper":"CalendarEvent_gfeWrapper__243F2"};